module.exports = __webpack_public_path__ + "static/media/Anfora_Royal_Bird.dfa0a591.png";